<template>
  <div class="posts clearfix">
    <div class="news_block latest">
      <h4>POPULAR&nbsp;POSTS</h4>
        <ul>
          <li v-for="data in fetchedData">
              <span>
                <router-link :to="'/blog/' + data.attributes.slug">
                  <img  v-bind:src="data.attributes.medium_image" class="img-responsive" width="80" height="80" alt="earth">
                </router-link>
              </span>
                <div class="news_in col-xs-8">
                  <p><router-link :to="'/blog/' + data.attributes.slug">{{data.attributes.title}}</router-link></p>
                    <small>{{data.attributes.event_date | convertDate}}</small>
                </div>
                <div class="clear"></div>
            </li>
        </ul>
      </div>
    </div>
</template>

<script>
import {HTTP} from '../http-common.js'
import * as moment from 'moment-timezone';

export default {
  name: 'popular',
  data () {
    return {
      fetchedData: [],
      error: false,
      title : null,
    }
  },
  filters: {
  	truncate: function(string, value=150) {
      if(string.length <= value) {
       return string;
       }
       else {
           return string.substring(0, value) + '...';
       }

    },
    escape: function(text){
      var txt = document.createElement("textarea");
      txt.innerHTML = text;
      var text = txt.value;
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    },
    convertDate: function(date){
      return moment(date).format('MMMM Do, YYYY')
    }
  },
  created: function(){
      this.fetchData()
  },
  methods : {
              fetchData(value='') {
                var url = 'blog?limit=3&order_by=hits'
                HTTP.get(url).then(response => {
                  if(response.status==200){
                    var jsonData =response
                    this.loading = false
                    this.fetchedData = jsonData.data.data
                    //console.log(this.fetchedData)
                  }
                })
                .catch(e => {
                  //this.errors.push(e)
                  this.error = true
                })
              }
  }
}
</script>



// WEBPACK FOOTER //
// Popular.vue?d05dba2a